module.exports = __webpack_public_path__ + "img/88b438b.png";